import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InAppSpy from "inapp-spy";
import { useToastMessage } from "./useToastMessage";

/**
 * in-app browser でのみ getUserMedia を試み、マイクが取れなかった場合に
 * 外部ブラウザで開き直すよう案内するトーストを表示する。
 * 通常ブラウザでは何もしない。
 */
export function useInAppMicCheck(): void {
  const toastMessage = useToastMessage();
  const { t } = useTranslation();

  useEffect(() => {
    if (!InAppSpy().isInApp) return;

    const notify = (): void => {
      toastMessage(t("Recording.inAppBrowserMicDenied"), "warning", {
        duration: null,
      });
    };

    if (!navigator.mediaDevices?.getUserMedia) {
      notify();
      return;
    }

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch((err) => {
        if (err instanceof DOMException && err.name === "NotAllowedError") {
          notify();
        }
      });
  }, [toastMessage, t]);
}
